module.exports = __webpack_public_path__ + "static/media/registry_advisor.1b16215b.svg";